import React, { useCallback, useState } from "react";
import { useMutation, gql } from "@apollo/client";
import { useDropzone } from "react-dropzone";
import { ReactComponent as CloseButton } from "../../../styles/closeButton.svg";
//Import Form Elements
import { Button, Checkbox, Form, Input, Select} from 'antd';
import type { FormInstance } from 'antd/es/form';

interface AddUserProps {
  onClose: () => void;
}

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  const { Option } = Select;
  

  
const AddPatient: React.FC<AddUserProps> = ({ onClose }) => {
  
  return (
    <div>
      <h2>Add Patient</h2>
      {/* Form fields go here */}
      <button onClick={onClose}>Back to Users</button>
      <Form
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="Username"
        name="username"
        rules={[{ required: true, message: 'Please enter username!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="NPI"
        name="NPI"
        rules={[{ required: true, message: 'Please enter NPI number!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Cell Phone"
        name="cellphone"
        rules={[{ required: true, message: 'Please enter cell phone number!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[{ required: true, message: 'Please enter email!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="role" label="Role" rules={[{ required: true }]}>
          <Select
            placeholder="Select role for user"
            allowClear
          >
            <Option value="physician">Physician</Option>
            <Option value="care">Care</Option>
          </Select>
      </Form.Item>
      <Form.Item name="alert-method" label="Alert Method" rules={[{ required: true }]}>
          <Select
            placeholder="Select alert method for user"
            allowClear
          >
            <Option value="physician">Physician</Option>
            <Option value="physician-care">Physician Care</Option>
          </Select>
      </Form.Item>
      <Form.Item name="status" label="Active" rules={[{ required: true }]}>
          <Select
            placeholder="Select user status"
            allowClear
          >
            <Option value="true">Yes</Option>
            <Option value="false">No</Option>
          </Select>
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
    </div>
  );
};
export default AddPatient;